import { COMPARE_WIDGET_SOURCE } from "GlobalEnum/WidgetSource";
import { AUTO_COMPLETE_SUGGESTION_TYPES } from "../constants";

function getResponseValue(payload, suggestionType, additionalInfo) {
  return `${payload.url}|${
    suggestionType === AUTO_COMPLETE_SUGGESTION_TYPES.upcomingModel
      ? "upcoming"
      : additionalInfo
  }`;
}

export const getSearchResultObject = (
  response,
  isMobile,
  responseLength,
  position
) => {
  const { additionalInfo = "", displayName, suggestionType } = response;
  let { payload } = response;
  if (!displayName || !payload || !payload.url) {
    return null;
  }
  const conditionalValues = {};
  if (suggestionType == AUTO_COMPLETE_SUGGESTION_TYPES.dualCompare) {
    const { versionSuggestion1, versionSuggestion2 } = payload;
    payload.url = `${payload.url}?source=${
      isMobile
        ? COMPARE_WIDGET_SOURCE.GlobalSearchCompareCarSuggestionMobile
        : COMPARE_WIDGET_SOURCE.GlobalSearchCompareCarSuggestionDesktop
    }`;
    // this is done for compare type links tracking in global search
    conditionalValues.versionSuggestion1 = versionSuggestion1;
    conditionalValues.versionSuggestion2 = versionSuggestion2;
  } else {
    const { makeMaskingName, maskingName, modelId } = payload;
    // this is done to track links other than compare types in global search
    conditionalValues.makeMaskingName = makeMaskingName;
    if (suggestionType !== AUTO_COMPLETE_SUGGESTION_TYPES.make) {
      conditionalValues.modelMaskingName = maskingName;
      conditionalValues.modelId = modelId;
    }
  }
  const isSuggestionCompareType =
    response.suggestionType === AUTO_COMPLETE_SUGGESTION_TYPES.dualCompare;
  const resultLabel = getResultsLabel({
    isSuggestionCompareType,
    ...conditionalValues,
  });
  const modelIdLabel = getModelIdLabel({
    isSuggestionCompareType,
    ...conditionalValues,
  });
  return {
    ...conditionalValues,
    label: displayName,
    value: getResponseValue(payload, suggestionType, additionalInfo),
    isFeatured: payload.isFeatured,
    "data-action": "Click",
    "data-count": responseLength,
    "data-position": position,
    "data-resultlabel": resultLabel,
    "data-modelidlabel": modelIdLabel,
    "data-islink":
      response.suggestionType === AUTO_COMPLETE_SUGGESTION_TYPES.link,
  };
};

const getResultsLabel = ({
  isSuggestionCompareType,
  makeMaskingName,
  modelMaskingName,
  versionSuggestion1,
  versionSuggestion2,
}) => {
  if (isSuggestionCompareType && versionSuggestion1 && versionSuggestion2) {
    //spaces are left intentionally between names
    return `${versionSuggestion1.makeName} ${versionSuggestion1.modelName} vs ${versionSuggestion2.makeName} ${versionSuggestion2.modelName}`;
  }
  if (makeMaskingName) {
    return `${makeMaskingName}${
      modelMaskingName ? ` ${modelMaskingName}` : ""
    }`;
  }
  return "";
};

const getModelIdLabel = ({
  isSuggestionCompareType,
  versionSuggestion1,
  versionSuggestion2,
  modelId,
}) => {
  if (isSuggestionCompareType && versionSuggestion1 && versionSuggestion2) {
    return `modelid1=${versionSuggestion1.modelId}|modelid2=${versionSuggestion2.modelId}`;
  }
  if (modelId) {
    return `modelid=${modelId}`;
  }
  return "";
};
